// Horse relationships card. Mirrors data-component="horse-relationships"
// from the approved HTML. Barn / Trainer / Veterinarian trio + open-
// relationships link.
//
// TODO(runtime): hydrate from services/relationships (confirmed service,
// no HTTP read endpoint yet). "Open relationships" routes to the
// Relationships customer tab (proposed - TODO runtime: no React port).
import type { ReactNode } from 'react';
import type { HorseProfile } from '../mockData.js';

export interface HorseRelationshipsProps {
  horse: HorseProfile;
  onOpen?: () => void;
}

export function HorseRelationships({ horse, onOpen }: HorseRelationshipsProps): ReactNode {
  return (
    <section className="card" data-component="horse-relationships">
      <div className="section-heading">
        <h3>People around {horse.name}</h3>
      </div>
      <div className="horse-people">
        <div>
          <span>Barn</span>
          <strong>{horse.relationships.barn}</strong>
        </div>
        <div>
          <span>Trainer</span>
          <strong>{horse.relationships.trainer}</strong>
        </div>
        <div>
          <span>Veterinarian</span>
          <strong>{horse.relationships.veterinarian}</strong>
        </div>
        <button className="text-btn" type="button" onClick={onOpen}>
          Open relationships &rarr;
        </button>
      </div>
    </section>
  );
}
